import script from "./communityBusinesses.vue?vue&type=script&lang=ts&setup=true"
export * from "./communityBusinesses.vue?vue&type=script&lang=ts&setup=true"

import "./communityBusinesses.vue?vue&type=style&index=0&id=7c1857d4&lang=less&scope=true"

const __exports__ = script;

export default __exports__